export interface PublicationFilterType {
  selectedPublication: server.dto.PublicationStatuses
}

export const initialPublicationFilter: PublicationFilterType = {
  selectedPublication: null
};